const { commonConfig } = require('@alfa-bank/assr-common-config');
const { dataLayerListener } = require('./src/counters/data-layer.cjs');
const { cdnPlugin } = require('@plotva/assr-core-plugins');
const { name, version, dependencies } = require('./package.json');
const { dependencies: privateDependencies } = require('./src/private/package.json');
const { dependencies: sideTeamDependencies } = require('./src/side-team/package.json');
const {
    ytm,
    ytmNoScript,
    ytmCookie,
    ytmSendUserParams,
    ytmSendEvent
} = require('./src/counters/ytm.cjs');
const { platformIdReady } = require('./src/counters/platform-id-ready.cjs');
const { alfaPartners } = require('./src/counters/partners.cjs');

const config = {
    ...commonConfig,
    postcss: {
        customPropertiesFile: 'node_modules/@alfalab/core-components-themes/site.css'
    },
    cssHashLen: 5,
    widgetsContexts: ['@alfa-bank', '@plotva'],
    additionalWidgetPackages: [],
    instanceName: name,
    instanceVersion: version,
    getDependencies: () => ({ ...dependencies, ...sideTeamDependencies, ...privateDependencies }),
    getCounters: (url, data) => {
        const { CUSTOM_YTM_ID, ENABLE_COUNTERS } = process.env;
        const {
            collectorData: { host },
            pageContent: { webAnalytics }
        } = data;
        const isCountersEnabled = ENABLE_COUNTERS === 'true';
        const enableYtm = isCountersEnabled && CUSTOM_YTM_ID;
        const ytmScripts = [
            ytmNoScript,
            ytmCookie,
            dataLayerListener,
            ytmSendUserParams,
            ytmSendEvent(webAnalytics)
        ];
        const headYTM = enableYtm ? ytm(url) : '';
        const bodyYTM = enableYtm ? ytmScripts.join('') : '';

        return {
            headCounters: [platformIdReady, headYTM],
            bodyCounters: [
                bodyYTM,
                isCountersEnabled ? alfaPartners(url) : ''
            ],
            endBodyCounters: []
        };
    },
    cdnReplacement: {
        enabled: true,
        viewLog: true
    },
    plugins: [
        {
            plugin: cdnPlugin,

            config: {
                cdnPublicPath: process.env.CDN_PUBLIC_PATH,
                domainPattern: '(https?:)?//alfabank[.]st'
            }
        }
    ]
};

module.exports = config;
